import { defineComponent as _defineComponent } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
import Button from 'primevue/button';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import Calendar from 'primevue/calendar';
import { onMounted, ref } from 'vue';
import { computed } from '@vue/reactivity';
import { Inertia } from '@inertiajs/inertia';
import RecordsTableHeader from '../../../Components/RecordsTableHeader.vue';
import { formatISODate } from '../../../Services/Utils';
import { trans, transChoice } from 'laravel-vue-i18n';
import { useMitt } from '../../../Plugins/mitt';
import MultiSelect from 'primevue/multiselect';
import { DateTime } from 'luxon';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Table',
    setup(__props, { expose }) {
        expose();
        const emitter = useMitt();
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            created_at_object: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
            plot: { value: null, matchMode: FilterMatchMode.IN },
        });
        const globalFilterFields = ['plot.code'];
        const page = usePage();
        const records = computed(() => (page.props.value.nutritionBalances || []).map((record) => ({
            ...record,
            created_at_object: DateTime.fromISO(record.created_at).toJSDate(),
        })));
        const plots = computed(() => {
            if (!records.value)
                return [];
            const plots = [];
            for (const record of records.value) {
                if (!plots.find((plot) => plot.id === record.plot.id)) {
                    plots.push(record.plot);
                }
            }
            return plots;
        });
        const reloadRecords = () => {
            Inertia.reload({
                only: ['nutritionBalances'],
            });
        };
        onMounted(() => reloadRecords());
        const openDetails = async (data) => emitter.emit('open-nutrition-balance-details', data);
        const __returned__ = { emitter, filters, globalFilterFields, page, records, plots, reloadRecords, openDetails, get Button() { return Button; }, DataTable, get Column() { return Column; }, get Calendar() { return Calendar; }, RecordsTableHeader, get formatISODate() { return formatISODate; }, get trans() { return trans; }, get transChoice() { return transChoice; }, get MultiSelect() { return MultiSelect; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
